import classNames from 'classnames';
import { observer } from 'mobx-react';
import { FC } from 'react';

import { Flex, Icon, Text, useBreakpoint } from '@servicetitan/anvil2';
import DiamongdIcon from '@servicetitan/anvil2/assets/icons/material/round/diamond.svg';
import IconLock from '@servicetitan/anvil2/assets/icons/material/round/lock.svg';
import { core } from '@servicetitan/anvil2/token';
import { useDependencies } from '@servicetitan/react-ioc';

import * as Styles from './topics-view.module.less';
import { MessageOption } from '../../common/components/message-option/message-option';
import { TopicViewModel } from '../../common/models/topic.model';
import { MainStore } from '../../common/stores/main.store';

export const TopicsViews: FC<{
    topics: TopicViewModel[];
    onTopicClick: (topic: TopicViewModel) => void;
}> = observer(({ topics, onTopicClick }) => {
    const [mainStore] = useDependencies<[MainStore]>(MainStore);

    // md is the border: md and up renders a 2×2 grid; smaller renders a 1×4 list.
    const breakpoint = useBreakpoint();
    const isTabletUp = !!breakpoint && ['md', 'lg', 'xl', 'xxl'].includes(breakpoint.name);

    return (
        <div className={classNames(Styles.grid, { [Styles.gridTablet]: isTabletUp })}>
            {topics.map(topic => (
                <MessageOption
                    key={topic.id}
                    disabled={!topic.enabled}
                    active={mainStore.selectedTopic && mainStore.selectedTopic.id === topic.id}
                    data-cy={`topic-card-${topic.id}`}
                    onClick={() => topic.enabled && onTopicClick(topic)}
                >
                    <Flex direction="column" className="w-100">
                        <div className={classNames(!topic.enabled && 'opacity-disabled')}>
                            <Flex justifyContent="space-between" className="m-b-half">
                                <Text size="medium">
                                    <b data-cy={`topic-card-${topic.id}-title`}>{topic.name}</b>
                                </Text>
                                {!topic.enabled && <Icon svg={IconLock} size="medium" />}
                            </Flex>
                            <Text
                                className={classNames({
                                    'm-b-1': !topic.enabled,
                                })}
                                size="small"
                                data-cy={`topic-card-${topic.id}-description`}
                            >
                                {topic.description}
                            </Text>
                        </div>
                        {!topic.enabled && (
                            <Flex justifyContent="flex-end">
                                <Flex
                                    direction="row"
                                    alignItems="center"
                                    gap="1"
                                    style={{
                                        padding: '4px',
                                        borderRadius: '3px',
                                        border: `1px solid ${core.primitive.ColorPurple400.value}`,
                                        backgroundColor: core.primitive.ColorPurple100.value,
                                    }}
                                >
                                    <Icon svg={DiamongdIcon} color="#6954C0" />
                                    <Text size="small" style={{ color: '#6954C0' }}>
                                        Upgrade to Field Pro
                                    </Text>
                                </Flex>
                            </Flex>
                        )}
                    </Flex>
                </MessageOption>
            ))}
        </div>
    );
});
